import React from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/branch_circuts.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';
import { useSetupBackUrl } from './use-setup-back-url';

/* istanbul ignore next -- @preserve */
export function DevicePowerUpInstructions() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { withSetupBackUrl } = useSetupBackUrl();
  const backURL = useParamBackUrl(withSetupBackUrl('../device-unplug-ev?direction=back'));

  return (
    <SlidingAnimationPageBase
      title={t('Common.device setup')}
      backURL={backURL}
      includeTopNavHamButton
      display="flex"
      flexDirection="column"
    >
      <Center flexDirection="column" px={3} textAlign="center" flex={1}>
        <Image data-testid="ev-charger-image" src={chargerImg} alt="EV Charger" my={4} />

        <Heading mt={2} size={'lg'}>
          {t('Set Up Hardware.activate wifi ap')}
        </Heading>
        <Text data-testid="ev-setup-text" mt={1}>
          {t('Set Up Hardware.restart ev charger')}
        </Text>
        <Text data-testid="ev-setup-text" mt={1}>
          {t('Set Up Hardware.connect charger wifi')}
        </Text>

        <ArcButton
          data-testid="ev-charger-continue"
          onClick={() => navigate(withSetupBackUrl('../device-wait-for-yellow-led'))}
          mt="auto"
          mb={8}
          w={'100%'}
          arcColor="#3DCD57"
        >
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
